/* eslint-disable react/prop-types */
import React, {memo} from 'react';

import {connect} from 'react-redux';

import * as APPDATA from '@/constants/pcConstAppData';
import * as APPSTYLE from '@/constants/pcConstAppStyle';

import '../status/AutoProfileStatus.less';

@connect((store) => ({
  isPCRunning: store.setupStore.isPCRunning,
  profileRunning: store.setupStore.profileRunning,
  currentPressureSensors: store.setupStore.currentPressureSensors,
  currentTiming: store.setupStore.currentTiming,
}))
class StatusParameters extends React.Component {
  shouldComponentUpdate(nextProps) {
    const {currentPressureSensors, currentTiming} = this.props;
    if (currentPressureSensors !== nextProps.currentPressureSensors) return true;
    if (currentTiming !== nextProps.currentTiming) return true;

    return false;
  }

  // eslint-disable-next-line class-methods-use-this
  generateStatusText = (statusText) => {
    const status = statusText.map((status, index) => (
      // <React.Fragment>
      <div
        className={`${APPSTYLE.COLUMN_11}rowHeightAutoProfile middleAlign`}
        // eslint-disable-next-line react/no-array-index-key
        key={index}
      >
        <div className={`${APPSTYLE.COLUMN_6}statusText middleAlign no-padding`}>
          <div
            key={status.label}
            className={`${APPSTYLE.COLUMN_FULL}no-padding properties-coloumn`}
          >
            <div className="middleAlign">
              <div
                className={`${APPSTYLE.COLUMN_8}no-padding`}
                style={{textAlign: 'right'}}
              >
                {/* <div className="row row-margin"> */}
                <span className="spanStyleInputField">{status.label}</span>
                {/* </div> */}
              </div>
              <div
                className={`${APPSTYLE.COLUMN_3}no-padding`}
                style={{textAlign: 'center'}}
              >
                {status.value === APPDATA.EMPTY_FIELD ? '' : status.value}
              </div>
              <div
                className={`${APPSTYLE.COLUMN_1}no-padding`}
                style={{textAlign: 'left'}}
              >
                <span className="spanStyleInputField unit">{status.unit}</span>
              </div>
            </div>
          </div>
        </div>
        {status.label2 !== undefined && (
          <div className={`${APPSTYLE.COLUMN_6}statusText middleAlign no-padding`}>
            <div
              key={status.label2}
              className={`${APPSTYLE.COLUMN_FULL}no-padding properties-coloumn`}
            >
              <div className="middleAlign">
                <div
                  className={`${APPSTYLE.COLUMN_8}no-padding`}
                  style={{textAlign: 'right'}}
                >
                  {/* <div className="row row-margin"> */}
                  <span className="spanStyleInputField">{status.label2}</span>
                  {/* </div> */}
                </div>
                <div
                  className={`${APPSTYLE.COLUMN_3}no-padding`}
                  style={{textAlign: 'center'}}
                >
                  {status.value2 === APPDATA.EMPTY_FIELD ? '' : status.value2}
                </div>
                <div
                  className={`${APPSTYLE.COLUMN_1}no-padding`}
                  style={{textAlign: 'left'}}
                >
                  <span className="spanStyleInputField unit">{status.unit2}</span>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      // </React.Fragment>
    ));
    return status;
  };

  render() {
    const {isPCRunning, currentPressureSensors, currentTiming} = this.props;

    const statusText = [
      {
        label: APPDATA.FIELD_NAME.DIAPHRAGM_PRESSURE,
        value: isPCRunning ? Number(parseFloat(currentPressureSensors.diaphragm).toFixed(4)) : 0,
        unit: APPDATA.UNIT.psi,
        label2: APPDATA.FIELD_NAME.DIAPHRAGM_FILL_TIME,
        value2: isPCRunning ? currentTiming[APPDATA.KEY.DiaphragmTimingOpen] : 0,
        unit2: APPDATA.UNIT.ms,
      },
      {
        label: APPDATA.FIELD_NAME.BOTTLE_PRESSURE,
        value: isPCRunning ? Number(parseFloat(currentPressureSensors.returnValve).toFixed(4)) : 0,
        unit: APPDATA.UNIT.psi,
        label2: APPDATA.FIELD_NAME.DIAPHRAGM_EMPTY_TIME,
        value2: isPCRunning ? currentTiming[APPDATA.KEY.DiaphragmTimingClose] : 0,
        unit2: APPDATA.UNIT.ms,
      },
    ];
    return <>{this.generateStatusText(statusText)}</>;
  }
}
export default memo(StatusParameters);
